import React from "react";
import ExtensionDetails from "./ExtensionDetails";
import GotoDetailsHeader from "./GotoDetailsHeader";

const ExtensionDetailsDrawerContent = ({
  extensionData,
  onAssignUser,
  onAssignDepartment,
  onAssignLocation,
  refetch,
  canAssignLocation,
}) => {
  return (
    <>
      <GotoDetailsHeader
        title={extensionData?.name}
        subtitleLabel="Extension"
        subtitle={extensionData?.number}
        status={extensionData?.isActive ? "Active" : "Inactive"}
      />
      <div className="mt-8">
        <ExtensionDetails
          extensionData={extensionData}
          onAssignUser={onAssignUser}
          onAssignDepartment={onAssignDepartment}
          onAssignLocation={onAssignLocation}
          refetch={refetch}
          canAssignLocation={canAssignLocation}
        />
      </div>
    </>
  );
};

export default ExtensionDetailsDrawerContent;
